<template>
	<div>
		<el-tree :data="value" :allow-drop="Allowdrop" :expand-on-click-node="false" :draggable="true" :accordion="true"  default-expand-all :indent="40" :props="{children:'haizi',label:'ming'}">
			<el-row slot-scope="{ node, data }">
				<el-col :span="12">
					<span class="el-avatar" @click="Shangchuanqian(data,0)" v-if="xianshitu" style="">
						<img :src="data.tu" v-if="data.tu" />
					</span>
					
					<span class="el-avatar" @click="Shangchuanqian(data,1)" v-if="xianshitu">
						<img :src="data.tu_mongren" v-if="data.tu_mongren" />
					</span>
					
					<input v-model="data.ming" />
					 <span class="fenleiid" v-if="data.id">ID:{{data.id}}</span>
				</el-col>
				<el-col :span="6">
					<el-button type="text" size="mini" @click="() => append(node,0)" v-if="node.level<cengji">新增子级</el-button>
					<el-button type="text" size="mini" @click="() => append(node,1)" v-if="node.level<cengji">新增同级</el-button>
					<el-button type="text" size="mini" @click="() => remove(node, data)">删除</el-button>
				</el-col>
			</el-row>
		</el-tree>
		<input type="file" name="file" id="shangchuan" @change="Shangchuanchenggong" />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				ming:0,
				url: '',
			}
		},
		props: {
			value: {
				type: Array,
			},
			cengji: {
				type: Number,
				default: 2
			},
			xianshitu:{
				type: Boolean,
				default: true
			}
		},
		methods: {
			append(e, k) {
				const newChild = {
					ming: '',
					tu: '',
				};
				if (k) {
					e.parent.data.push(newChild);
				} else {
					if (!e.data.haizi) {
						this.$set(e.data, 'haizi', []);
					}
					e.data.haizi.push(newChild);
				}
			},
			remove(node, data) {
				const parent = node.parent;
				const children = parent.data.haizi || parent.data;
				const index = children.findIndex(d => d.id === data.id);
				children.splice(index, 1);
			},
			Shangchuanchenggong(e) {
				var that = this;
				const data = new FormData();
				data.append('file', e.target.files[0]);				
				this.$axios.post(this.$url + "?k=wenjian&leixing=tu", data, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'kouling':that.$yonghu.kouling
					},
				}).then(res => {
					if (res.data.shi) {
						
						if(that.ming==1){
							that.$set(that._st, 'tu_mongren', res.data.shu.url)
						}else{
							that.$set(that._st, 'tu', res.data.shu.url)
						}
						
					} else {
						that.$xiaoxi(res.data.shu);
					}
				}).catch(err => {
					console.log(err);
				});

			},
			Shangchuanqian(e,a) {
				if(a==1){
					this.ming=1
				}else{
					this.ming=0
				}
				this._st = e;
				document.getElementById("shangchuan").click();
			},
			Allowdrop(a, b, c) {
				if (a.data.haizi) {
					return false;
				} else if (b.level < this.cengji) {
					return true;
				} else if (b.level == this.cengji) {
					return c != 'inner';
				} else {
					return false;
				}

			}
		}
	};
</script>
<style>
	.el-tree {
		border-left: 1px solid #E4E7ED;
		border-top: 1px solid #E4E7ED;
		border-right: 1px solid #E4E7ED;
	}
    .el-col{display: flex;align-items: center;}
	.el-tree-node__content {
		height: 40px;
		border-bottom: 1px solid #E4E7ED;
	}

	.el-row {
		width: 100%;
	}

	.el-tree input {
		padding: 5px;
		border: 1px solid #f2f4f8;	
	}

	.el-tree .el-avatar {
		background-image: url(https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png);
		background-size: 100%;
		width: 27px;
		height: 27px;
	
	}

	#shangchuan {
		display: none;
	}

	.el-tree .el-avatar img {
		width: 100%;
		height: 100%;
	}
	.fenleiid{font-size: 10px;color: #C0C4CC;padding-left: 10px;}
</style>
